export const ckConfig = {
    toolbar: {
        items: ['heading', '|', 'bold', 'italic', '|', 'Link', '|', 'undo', 'redo']
    },
    language: 'de'
};
